var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React, { Component } from "react";
import { KEYS_CHARCODE } from "../consts";
import { ClearIcon, SearchIcon } from "../Icons";
import styles from "../statics/styles/text-search-input-scss";
class TextSearchInput extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "input", null);
    __publicField(this, "onChange", (e) => this.props.onChange(e.target.value));
    __publicField(this, "onCloseRequested", () => {
      this.props.onClose?.();
    });
    __publicField(this, "handleKeyPress", (e) => {
      if (e.charCode === KEYS_CHARCODE.ESCAPE) {
        this.onCloseRequested();
      }
      if (e.charCode === KEYS_CHARCODE.ENTER) {
        const elements = Array.from(
          document.querySelectorAll("button,input")
        );
        const searchInputIndex = elements.indexOf(e.target);
        elements[searchInputIndex + 1]?.click();
      }
    });
    __publicField(this, "handleClearText", () => this.props.onChange(""));
  }
  componentDidMount() {
    if (this.input) {
      setTimeout(() => this.input?.focus(), 0);
      this.input.setSelectionRange(0, this.input.value.length);
    }
  }
  render() {
    const { placeHolder, value } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: styles.container }, /* @__PURE__ */ React.createElement(SearchIcon, { className: styles.prefixIcon }), /* @__PURE__ */ React.createElement(
      "input",
      {
        ref: (ref) => {
          this.input = ref;
        },
        className: styles.input,
        placeholder: placeHolder,
        onKeyPress: this.handleKeyPress,
        onChange: this.onChange,
        value
      }
    ), value && /* @__PURE__ */ React.createElement(ClearIcon, { className: styles.suffixIcon, onClick: this.handleClearText }));
  }
}
export {
  TextSearchInput as default
};
//# sourceMappingURL=TextSearchInput.js.map
